import axios from './requestClient';

export async function fetchOrganizations(params) {
  return axios.get('/api/v1/Organization', {
    params,
  });
}

export async function fetchOrganization(id) {
  return axios.get(`/api/v1/Organization/${id}`);
}

export async function fetchOrganizationMembers(id, params) {
  return axios.get(`/api/v1/Organization/${id}/Members`, { params });
}

export async function fetchOrganizationAdmins(id, params) {
  return axios.get(`/api/v1/Organization/${id}/Admins`, { params });
}

export async function fetchConnectedOrganizations(params) {
  return axios.get(`/api/v1/Organization/ConnectedOrganizations`, { params });
}

export async function postConnectedOrganization(id, data) {
  return axios.post(`/api/v1/Organization/${id}/ConnectedOrganizations`, data);
}

export async function deleteConnectedOrganization(id, data) {
  return axios.delete(`/api/v1/Organization/${id}/ConnectedOrganizations`, {
    data,
  });
}

export async function postOrganizationMembers(organizationId, userIds) {
  return axios.post(`/api/v1/Organization/${organizationId}/Members`, {
    userIds,
  });
}

export async function postOrganizationAdmins(organizationId, userIds) {
  return axios.post(`/api/v1/Organization/${organizationId}/Admins`, {
    userIds,
  });
}

export async function postOrganization(data) {
  return axios.post('/api/v1/Organization', data);
}

export async function putOrganization(id, data) {
  return axios.put(`/api/v1/Organization/${id}`, data);
}

export async function deleteOrganizationMembers(id, userIds, params) {
  return axios.delete(`/api/v1/Organization/${id}/Members`, {
    data: { userIds },
    params,
  });
}

export async function deleteOrganizationAdmins(id, userIds, params) {
  return axios.delete(`/api/v1/Organization/${id}/Admins`, {
    data: { userIds },
    params,
  });
}

export async function deleteOrganization(id) {
  return axios.delete(`/api/v1/Organization/${id}`);
}
